"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapPickupPoint = void 0;
var _globalApiClientReact = require("@ori/global-api-client-react");
var _net = require("../models/graphql-types/net");
// TODO -- Remove when DeliveryMethodType is used in all of delivery step instead of GlobalShoppingDeliveryChannelDtoDeliveryMethod.
const parseDeliveryMethod = deliveryMethod => {
  switch (deliveryMethod) {
    case _net.DeliveryMethodType.DepartmentStore:
      return _globalApiClientReact.GlobalShoppingDeliveryChannelDtoDeliveryMethod.DepartmentStore;
    case _net.DeliveryMethodType.Home:
      return _globalApiClientReact.GlobalShoppingDeliveryChannelDtoDeliveryMethod.Home;
    case _net.DeliveryMethodType.Lpo:
      return _globalApiClientReact.GlobalShoppingDeliveryChannelDtoDeliveryMethod.Lpo;
    case _net.DeliveryMethodType.PickupPoint:
      return _globalApiClientReact.GlobalShoppingDeliveryChannelDtoDeliveryMethod.PickupPoint;
    case _net.DeliveryMethodType.PostOffice:
      return _globalApiClientReact.GlobalShoppingDeliveryChannelDtoDeliveryMethod.PostOffice;
    case _net.DeliveryMethodType.Spo:
      return _globalApiClientReact.GlobalShoppingDeliveryChannelDtoDeliveryMethod.Spo;
    case _net.DeliveryMethodType.NearestPostOffice:
      return _globalApiClientReact.GlobalShoppingDeliveryChannelDtoDeliveryMethod.NearestPostOffice;
    case _net.DeliveryMethodType.ParcelLocker:
      return _globalApiClientReact.GlobalShoppingDeliveryChannelDtoDeliveryMethod.ParcelLocker;
    default:
      return _globalApiClientReact.GlobalShoppingDeliveryChannelDtoDeliveryMethod.PickupPoint;
  }
};
const mapPickupPoint = deliveryChannel => ({
  addressId: deliveryChannel.deliveryChannel?.address?.addressId ? Number(deliveryChannel.deliveryChannel.address.addressId) : undefined,
  city: deliveryChannel.deliveryChannel?.address?.city ?? '',
  // TODO -- Remove type casting when type generation is fixed.
  deliveryChannelId: deliveryChannel.deliveryChannelId,
  deliveryMethod: parseDeliveryMethod(deliveryChannel.deliveryChannel?.deliveryMethod),
  description: deliveryChannel.deliveryChannel?.description ?? '',
  estimatedDeliveryDate: deliveryChannel.estimatedDeliveryDate ? new Date(deliveryChannel.estimatedDeliveryDate) : undefined,
  isShippingJoker: deliveryChannel.isShippingJoker,
  latitude: deliveryChannel.deliveryChannel?.coordinates?.latitude ?? undefined,
  longitude: deliveryChannel.deliveryChannel?.coordinates?.longitude ?? undefined,
  // TODO -- Remove type casting when type generation is fixed.
  originalShippingFee: deliveryChannel.originalShippingFee ?? undefined,
  outOfStockQuantity: deliveryChannel.outOfStockQuantity,
  // TODO -- Remove type casting when type generation is fixed.
  shippingFee: deliveryChannel.shippingFee,
  streetAddress: deliveryChannel.deliveryChannel?.address?.streetAddress ?? '',
  telephoneNumber: deliveryChannel.deliveryChannel?.telephoneNumber ?? undefined,
  workingHours: deliveryChannel.deliveryChannel?.workingHours ?? undefined,
  zipcode: deliveryChannel.deliveryChannel?.address?.zipcode ?? ''
});
exports.mapPickupPoint = mapPickupPoint;